export const parseSongInfo = (filename: string) => {
  // Remove file extension
  const nameWithoutExt = filename.replace(/\.[^/.]+$/, "");
  
  // Try to split by " - " first
  const parts = nameWithoutExt.split(" - ");
  
  if (parts.length >= 2) {
    return {
      artist: parts[0].trim(),
      title: parts.slice(1).join(" - ").trim()
    };
  }
  
  // If no separator found, return the whole name as title
  return {
    artist: "",
    title: nameWithoutExt.trim()
  };
};